import { render, staticRenderFns } from "./doc_files.vue?vue&type=template&id=47bc2c42&scoped=true&"
import script from "./doc_files.vue?vue&type=script&lang=js&"
export * from "./doc_files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bc2c42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47bc2c42')) {
      api.createRecord('47bc2c42', component.options)
    } else {
      api.reload('47bc2c42', component.options)
    }
    module.hot.accept("./doc_files.vue?vue&type=template&id=47bc2c42&scoped=true&", function () {
      api.rerender('47bc2c42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_enginer/doc/edit/tabs/doc_files.vue"
export default component.exports